import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BUTTONS_FLAGS;
export var LEFT_BUTTON = 0;
export var RIGHT_BUTTON = 2;

// the values for each button in MouseEvent.buttons
export var BUTTONS_FLAGS = (_BUTTONS_FLAGS = {}, _defineProperty(_BUTTONS_FLAGS, LEFT_BUTTON, 1), _defineProperty(_BUTTONS_FLAGS, RIGHT_BUTTON, 2), _BUTTONS_FLAGS);
export function buttonStillPressed(e, button) {
  var flag = BUTTONS_FLAGS[button];
  return e.buttons === undefined || (e.buttons & flag) !== flag;
}